import React from 'react';

import Chapter from '../Chapter';

const DEFAULT_COLOR = '#000000';
const DEFAULT_DURATION = 8;

type ColorChapterData = {
    color?: string,
    duration?: number,
};

export default class ColorChapter extends Chapter<ColorChapterData> {
    component = () => (
        <div
            style={{
                width: '100%',
                height: '100%',
                backgroundColor: this.data?.color || DEFAULT_COLOR,
            }}
        />
    );

    calculateDuration() {
        const duration = Number(this.data?.duration);

        if (!Number.isFinite(duration) || duration <= 0) {
            return DEFAULT_DURATION;
        }

        return duration;
    }
}
